export default __webpack_public_path__ + "static/t1-753fee77cf2ed2d50d34e819652a72b4.jpg";